module.exports = __webpack_public_path__ + "static/pic09-64b7376e3f363a535ec5b06e01d016a2.jpg";